import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FooterDropdownSectionProps {
  title: string;
  children: React.ReactNode;
}

const FooterDropdownSection = ({ title, children }: FooterDropdownSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div 
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className="flex items-center justify-between w-full text-left group cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 
          className="text-lg font-semibold transition-colors"
          style={{ 
            color: '#D4AF37',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
          }}
        >
          {title}
        </h4>
        <ChevronDown 
          size={20} 
          className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
          style={{ color: '#D4AF37' }}
        />
      </button>
      
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="space-y-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FooterDropdownSection;
